module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17603/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp1.svg"